import React from "react";
import { FormattedMessage } from "react-intl";
import { Badge, Typography } from "antd";
import { getEmployeeStatus } from "../employeeDetailsSlice";
import { getAgeByDate } from "../../../components/util/helpers";

const { Title } = Typography;
const EmployeeTitle = (props) => {
  const { activeEntity } = props;

  const employeeStatus = getEmployeeStatus(activeEntity);

  if (!activeEntity.id) {
    return null;
  }
  const employeeAge =
    activeEntity && activeEntity.birthday
      ? getAgeByDate(activeEntity.birthday)
      : null;
  const arr = [`${activeEntity.surename} ${activeEntity.first_name}`];
  if (employeeAge) {
    arr.push(employeeAge);
  }
  const truncate = (input, num) =>
    input.length > num ? `${input.substring(0, num)}...` : input;
  const name = activeEntity ? truncate(arr.join(", "), 24) : "";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-end",
        height: "50px",
        marginTop: "10px",
      }}
    >
      <Title level={1}>{name}</Title>
      <Badge
        className="status_badge"
        status={employeeStatus}
        text={<FormattedMessage id={`app.employees.${employeeStatus}`} />}
      />
    </div>
  );
};

export default EmployeeTitle;
